import React, { useState } from 'react'
import DotsLoading from 'components/loadings/dotsLoading'
import Item from './item'
import InfiniteScroll from 'react-infinite-scroll-component'
import {
    FetchNextPageOptions,
    InfiniteData,
    InfiniteQueryObserverResult,
} from 'react-query'
import { IoSearch, IoClose, IoOptionsOutline } from 'react-icons/io5'
import { FaArrowRight } from 'react-icons/fa6'
interface ILoansProps {
    data: InfiniteData<IMoneyPoolFundLoans> | undefined
    isLoading: boolean
    fetchNextPage: (
        options?: FetchNextPageOptions | undefined
    ) => Promise<InfiniteQueryObserverResult<IMoneyPoolFundLoans, unknown>>
    isError: boolean
    setSearchLoans: React.Dispatch<React.SetStateAction<string>>
    searchLoan: string
    setSearchLoan: React.Dispatch<React.SetStateAction<string>>
    isManager?: boolean
    isHiddenLoans?: boolean
}
export default function Loans({
    data,
    isLoading,
    fetchNextPage,
    isError,
    setSearchLoans,
    searchLoan,
    setSearchLoan,
    isManager,
    isHiddenLoans,
}: ILoansProps) {
    const [searchMode, setSearchMode] = useState(false)

    const closeSearch = () => {
        setSearchMode(false)
        setSearchLoan('')
    }

    return (
        <div className="bg-white">
            {isManager &&
                (searchMode ? (
                    <div className="flex w-full items-center bg-white">
                        <button
                            type="button"
                            onClick={closeSearch}
                            className="ml-3 shrink-0 p-1 text-green-1"
                        >
                            <FaArrowRight className="h-4 w-4" />
                        </button>
                        <input
                            type="text"
                            autoFocus
                            className="w-full bg-white p-4 text-right text-[15px] text-black outline-0 placeholder:text-text-muted"
                            onChange={(e) => setSearchLoan(e.target.value)}
                            value={searchLoan}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') setSearchLoans(searchLoan)
                            }}
                            placeholder="جستجوی نام و شماره تلفن"
                        />
                        <button
                            type="button"
                            onClick={closeSearch}
                            className="mr-3 shrink-0 p-1 text-black"
                        >
                            <IoClose className="h-4 w-4" />
                        </button>
                    </div>
                ) : (
                    <div className="flex items-center justify-between pl-4 pr-4 pt-4 pb-2">
                        <button
                            type="button"
                            onClick={() => setSearchMode(true)}
                            className="p-[5px] text-green-1"
                        >
                            <IoSearch className="h-[22px] w-[22px]" />
                        </button>
                        <button
                            type="button"
                            className="flex items-center gap-1 text-green-1"
                        >
                            <span className="text-base font-bold text-green-1">
                                فیلتر
                            </span>
                            <IoOptionsOutline className="h-[22px] w-[22px] p-[1px]" />
                        </button>
                    </div>
                ))}
            {!isLoading && data ? (
                <InfiniteScroll
                    next={fetchNextPage}
                    hasMore={
                        data
                            ? data?.pages[data.pages.length - 1].next
                                ? true
                                : false
                            : false
                    }
                    dataLength={
                        data ? data.pages.flatMap((x) => x.results).length : 0
                    }
                    loader={<DotsLoading />}
                >
                    {isHiddenLoans && !isManager && (
                        <p className="mt-2 text-center text-sm text-black">
                            فقط وام‌های خودتان را می‌بینید
                        </p>
                    )}
                    <div className="pt-2">
                        {data.pages
                            .flatMap((x) => x.results)
                            .map((item) => (
                                <Item item={item} key={item.id} />
                            ))}
                    </div>
                </InfiniteScroll>
            ) : (
                <>
                    {isError ? (
                        <p className="my-8 text-center text-sm text-text-secondary">
                            وامی وجود ندارد
                        </p>
                    ) : (
                        <DotsLoading />
                    )}
                </>
            )}
        </div>
    )
}
